import React, { Component } from 'react';
import { connect } from 'react-redux';
import Cookies from 'universal-cookie';
import SocialPersonOutline from 'material-ui/svg-icons/social/person-outline'
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider'

const cookies = new Cookies();

export class Help extends Component {

  render() {
    const loc = cookies.get('locale')

    return (
      <div className='about'>
        <div className='comment_header'>
          node-node-nodeはエンジニアの集合知を図解するSNS
        </div>
        集合知を使ってシステムが自動的に各IT技術の関係を図に示すのがこのSNSの目的。<br />
        <br />
        例えばあなたが初めて「データベース」を学ぶとすると、GoogleでMySQLやPostgreSQL、Redisとキーワードを入れて調べる前に「これらは全てデータベースである」という関係性を知らなければならない。それは各用語をググってもヒットしない。そこは図で示した方が理解が容易になる。<br />
        例えばこのように<br />
           │ <br />
           ├─ データベース<br />
           │    ├── MySQL<br />
           │    ├── PostgreSQL<br />
           │    └── Redis<br />
      <br />
      これを集合知を使って図解するSNSがnode-node-node。
        <br />
        <div className='comment_header'>
          使い方
        </div>
        <h2>[1] クリック <br /></h2>
        ノードはクリックすると開いて子ノードが出てきます<br />
        <br />
        <img src="/images/gif/opening.gif" alt="opening"/>
        <br />
        <br />
        <h2>[2] ドラッグ<br /></h2>
        ノードはドラッグして動かせます<br />
        <br />
        <img src="/images/gif/dragging.gif" alt="dragging"/>
        <br />
        <br />
        <h2>[3] ノード作成<br /></h2>
        +  ボタンを押すとそのノードに関連するあなたのノードが作成できます<br />
        <br />
        <img src="/images/gif/create.png" alt="create"/>
        <br />
        <h3>
          node-node-nodeはエンジニアの集合知を結集して、大きなノードグラフを創ることを目指しています。ぜひご参加ください。</h3>
        <br />
        <br />
        <div className='comment_header'>
          ボタンの説明
        </div>
        <br />
        <img src="/images/gif/node.png" alt="node"/><br />
        <br />
        @＜ユーザー名＞<br />
        ノード作成者のID。クリックすると作者のノードへ行きます<br />
        <br />
        <br />
        <i className="far fa-comment fa-lg" /><br />
        クリックすると子ノードが作成できます<br />
        <br />
        -<br />
        クリックすると開いたノードが閉じます<br />
        <br />
        <i className="far fa-thumbs-up fa-lg" /><br />
      ノードがLikeできます。Likeしたノードはマイページで確認できます<br />
        <br />
        <i class="fas fa-pencil-alt fa-lg" /><br />
        ノードを編集できます（自分のノードのみ）<br />
        <br />
        <i class="fas fa-trash-alt fa-lg" /><br />
        ノードを削除します（自分のノードのみ）<br />
        <br />
        <br />
        <div className='comment_header'>
          詳しい使い方
        </div>
        <h2>すべてドラッグ<br /></h2>
        ノードが無い場所（バックグラウンド）をドラッグすると全体を動かせます
        <br />
        <br />
        <img src="/images/gif/base_dragging.gif" alt="base dragging"/><br />
        <br />
        <br />
        <h2>ユーザー登録（無料）<br /></h2>
        <br />
        右上メニューバーのこのアイコンをクリックしてご登録ください。
        <MuiThemeProvider>
          <SocialPersonOutline color="#606060" style={{}}/>
        </MuiThemeProvider>
        <br />
        <br />
        <div className='comment_header'>
          お問い合わせ、ご要望、ご感想
        </div>
        <br />
        <h2><a href="https://goo.gl/forms/YqIWnK59hTUqNrn73">node-node-node 連絡フォーム</a></h2>
        <br />
        ご連絡お待ちしてます。
        <br />
        <br />
        <br />
      </div>
    )
  }
}

const mapStateToProps = state => ({
  client: state.client,
  server: state.server
});

const mapDispatchToProps = {
}

export default connect(mapStateToProps, mapDispatchToProps)(Help)



// WEBPACK FOOTER //
// ./src/components/fixedComponents/Help.js